import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import {
   DropdownMenu,
   DropdownMenuContent,
   DropdownMenuItem,
   DropdownMenuTrigger,
} from '@ifixit/ui/components/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@ifixit/ui/components/tooltip';
import { cn } from '@ifixit/ui/lib/utils';
import { tiptapButtonClassName } from './TiptapButton';
import { useEditorContext, useEditorSelector } from '../editor_context';

export const TextStyleDropdown = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isHeading2: editor.isActive('heading', { level: 2 }),
      isHeading3: editor.isActive('heading', { level: 3 }),
      isParagraph: editor.isActive('paragraph'),
   }));

   if (!state) {
      return null;
   }

   const handleOpenChange = (open: boolean) => {
      if (!open) {
         setTimeout(() => editor.commands.focus(), 50);
      }
   };

   return (
      <Tooltip>
         <DropdownMenu onOpenChange={handleOpenChange}>
            <TooltipTrigger asChild>
               <DropdownMenuTrigger asChild>
                  <button
                     type="button"
                     aria-label={_js('Text style')}
                     className={cn(tiptapButtonClassName, 'p-1')}
                  >
                     <span className="inline-flex items-center gap-[7px]">
                        <FaIcon name="paragraph" />
                        <FaIcon name="chevron-down" />
                     </span>
                  </button>
               </DropdownMenuTrigger>
            </TooltipTrigger>
            <DropdownMenuContent align="start" className="p-0">
               <DropdownMenuItem
                  disabled={state.isHeading2}
                  onSelect={() => editor.chain().focus().setHeading({ level: 2 }).run()}
                  className="h-16"
               >
                  <span className="text-4xl font-bold text-gray-900">
                     {
                        /* Translators: "header" as in the text at the top of a page */
                        _js('Header')
                     }
                  </span>
               </DropdownMenuItem>
               <DropdownMenuItem
                  disabled={state.isHeading3}
                  onSelect={() => editor.chain().focus().setHeading({ level: 3 }).run()}
                  className="h-16"
               >
                  <span className="text-2xl font-semibold text-gray-600">
                     {
                        /* Translators: "subheader" as in a secondary header on the top of a page */
                        _js('Subheader')
                     }
                  </span>
               </DropdownMenuItem>
               <DropdownMenuItem
                  disabled={state.isParagraph}
                  onSelect={() => editor.chain().focus().setParagraph().run()}
                  className="h-16"
               >
                  <span className="text-base">
                     {
                        /* Translators: "paragraph" as in regular text */
                        _js('Paragraph')
                     }
                  </span>
               </DropdownMenuItem>
            </DropdownMenuContent>
         </DropdownMenu>
         <TooltipContent side="top" align="start">
            {_js('Text style')}
         </TooltipContent>
      </Tooltip>
   );
};
